import React, { useEffect, useState, useCallback } from 'react';
import CenterDashboardComponent from '../../components/center/CenterDashboardComponent';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { loadClubList } from '../../modules/clubs/clubs';
import * as statisticsAPI from '../../lib/api/statistics';

const CenterDashboardContainer = ({ history }) => {
  const dispatch = useDispatch();
  const { clubs, loading: clubsLoading, socketKey, user } = useSelector(
    ({ clubs, club, loading, user, socket }) => ({
      clubs: clubs.clubs,
      socketKey: socket.socketKey,
      user: user.user,
      loading: loading['clubs/LOAD_CLUB_LIST'],
    }),
  );

  useEffect(() => {
    if (user) {
      dispatch(
        loadClubList({
          centerID: user.centerID,
          socketKey,
        }),
      );
    }
  }, [user, socketKey, dispatch]);

  const now = new Date();
  // 년도별 데이터 섹션용 년도
  const [yearSectionYear, setYearSectionYear] = useState(now.getFullYear());
  // 월별 데이터 섹션용 년도와 월
  const [monthSectionYear, setMonthSectionYear] = useState(now.getFullYear());
  const [monthSectionMonth, setMonthSectionMonth] = useState(now.getMonth() + 1);
  const [yearData, setYearData] = useState(null);
  const [monthData, setMonthData] = useState(null);
  const [yearLoading, setYearLoading] = useState(false);
  const [monthLoading, setMonthLoading] = useState(false);
  const [dataError, setDataError] = useState(null);
  // 일별 상세
  const [dayDetail, setDayDetail] = useState(null);
  const [dayDetailLoading, setDayDetailLoading] = useState(false);
  const [dayDetailError, setDayDetailError] = useState(null);

  const fetchYearData = useCallback(async () => {
    console.log(`fetchYearData: ${user?.centerID}, ${socketKey}, ${yearSectionYear}`);
   if (!user?.centerID || !socketKey) return;
    setYearLoading(true);
    setDataError(null);
    try {
      const res = await statisticsAPI.loadDashboardYear({
        centerID: user.centerID,
        socketKey,
        year: yearSectionYear,
      });
      const clubs = (res.data && res.data.clubs) || [];
      setYearData(clubs);
    } catch (e) {
      setDataError(e.message || '데이터 로드 실패');
      setYearData([]);
    } finally {
      setYearLoading(false);
    }
  }, [user?.centerID, socketKey, yearSectionYear]);

  const fetchMonthData = useCallback(async () => {
    console.log(`fetchMonthData: ${user?.centerID}, ${socketKey}, ${monthSectionYear}, ${monthSectionMonth}`);
   if (!user?.centerID || !socketKey) return;
    setMonthLoading(true);
    setDataError(null);
    try {
      const res = await statisticsAPI.loadDashboardMonth({
        centerID: user.centerID,
        socketKey,
        year: monthSectionYear,
        month: monthSectionMonth,
      });
      const clubs = (res.data && res.data.clubs) || [];
      setMonthData(clubs);
    } catch (e) {
      setDataError(e.message || '데이터 로드 실패');
      setMonthData([]);
    } finally {
      setMonthLoading(false);
    }
  }, [user?.centerID, socketKey, monthSectionYear, monthSectionMonth]);

  useEffect(() => {
    //if (user?.centerID && socketKey) fetchYearData();
    if (socketKey) fetchYearData();
  }, [fetchYearData, user?.centerID, socketKey]);

  useEffect(() => {
    //if (user?.centerID && socketKey) fetchMonthData();
    if (socketKey) fetchMonthData();
  }, [fetchMonthData, user?.centerID, socketKey]);

  // 년도별 데이터 섹션의 년도 변경
  const onYearPrev = useCallback(() => setYearSectionYear((y) => y - 1), []);
  const onYearNext = useCallback(() => setYearSectionYear((y) => y + 1), []);
  const onChangeYear = useCallback((year) => {
    setYearSectionYear(year);
  }, []);

  // 월별 데이터 섹션의 월 변경
  const onMonthPrev = useCallback(() => {
    setMonthSectionMonth((m) => {
      if (m <= 1) {
        return 12; // 년도는 변경하지 않고 월만 변경
      }
      return m - 1;
    });
  }, []);
  const onMonthNext = useCallback(() => {
    setMonthSectionMonth((m) => {
      if (m >= 12) {
        return 1; // 년도는 변경하지 않고 월만 변경
      }
      return m + 1;
    });
  }, []);
  const onChangeMonth = useCallback((year, month) => {
    // 월 데이터 섹션에서 선택한 년도와 월로 변경 (년 데이터 섹션의 년도는 영향 없음)
    setMonthSectionYear(year);
    setMonthSectionMonth(month);
  }, []);
  const onRequestDayDetail = useCallback(async ({ year, month, day }) => {
    if (!socketKey) return;
    setDayDetailLoading(true);
    setDayDetailError(null);
    try {
      const res = await statisticsAPI.loadDashboardDay({
        centerID: user?.centerID ?? 5,
        socketKey,
        year,
        month,
        day,
      });
      setDayDetail(res.data);
    } catch (e) {
      setDayDetailError(e.message || '일별 데이터 로드 실패');
      setDayDetail(null);
    } finally {
      setDayDetailLoading(false);
    }
  }, [socketKey, user?.centerID]);

  const loading = clubsLoading;

  return (
    <CenterDashboardComponent
      yearData={yearData}
      monthData={monthData}
      selectedYear={yearSectionYear}
      selectedMonth={monthSectionMonth}
      monthSectionYear={monthSectionYear}
      loading={loading}
      yearLoading={yearLoading}
      monthLoading={monthLoading}
      dayDetail={dayDetail}
      dayDetailLoading={dayDetailLoading}
      dayDetailError={dayDetailError}
      dataError={dataError}
      onYearPrev={onYearPrev}
      onYearNext={onYearNext}
      onMonthPrev={onMonthPrev}
      onMonthNext={onMonthNext}
      onChangeMonth={onChangeMonth}
      onChangeYear={onChangeYear}
      onRequestDayDetail={onRequestDayDetail}
    />
  );
};

export default withRouter(CenterDashboardContainer);
